<template>
    <footer class="o2ositefooter">
      <img alt="Cancer Support Community | Gildas Club logos" src="/images/2022-logo-csc-gildasclub.png"/>
    </footer>
</template>


<script>
export default {
  name: "SiteFooter",
  
};
</script>